import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { id } from '@swimlane/ngx-charts/release/utils';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ScrumboardConfirmDialogComponent } from './board/scrumboard-confirm-dialog/scrumboard-confirm-dialog.component';

@Injectable({
    providedIn: 'root'
})

export class CardChartStatus {
    completed: any;
    remaining: any;
    total: any;
}
export class ChartDetails {
    planned = new CardChartStatus();
    unPlanned = new CardChartStatus();
    previousSprint = new CardChartStatus();
    movedToBacklogs: any;
}


@Injectable({
    providedIn: 'root'
})

export class ScrumboardService implements Resolve<any>
{
    boards = [];
    routeParams: any;
    board: any;
    objectId: any;
    taskdetailscrum: any;
    onBoardsChanged: BehaviorSubject<any>;
    onBoardChanged: BehaviorSubject<any>;
    taskId: any;
    projectId: any;
    boardList = [];
    currentAssignees = [];
    leaderProject = [];
    userId: any;
    empRole = '';
    taskFrom: string;
    taskTo: string;
    currentUser: any;
    taskToId: any;
    backlogResult = [];
    boardRule = []
    acceptedListName: any;
    storyPoints = new ChartDetails;
    tasks = new ChartDetails;
    hours = new ChartDetails;
    taskFromId: any;
    cardNumber: any;
    confirmDialogRef: MatDialogRef<ScrumboardConfirmDialogComponent>;
    defaultSprintId: any;
    tenantId = '';

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private parseService: ParseService,
        private toastr: ToastrService,
        private queryInterface: QueryInterface,
        private storageConfiguration: StorageConfiguration,
        private hardCodedValues: HardCodedValues,
        private _matDialog: MatDialog
    ) {
        // Set the defaults
        this.onBoardsChanged = new BehaviorSubject([]);
        this.onBoardChanged = new BehaviorSubject([]);

        this.currentUser = this.parseService.instance.User.current();
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.userId = this.parseService.instance.User.current() ? this.parseService.instance.User.current().id : '';
        this.getRoleBasedBoard();
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getBoards()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /**
     * Get boards
     *
     * @returns {Promise<any>}
     */
    getBoards(): Promise<any> {
        let taskdetail;
        let list = [];
        let boardMember = [];
        return new Promise(async (resolve, reject) => {
            boardMember = await this.getRoleBasedBoard();

            let boardInstance = this.parseService.instance.Object.extend('Sprint');
            let query = new this.parseService.instance.Query(boardInstance);
            query.descending('createdAt');
            query.include('project');
            query.equalTo('isActive', true);
            if (this.empRole != 'Admin') {
                query.containedIn('project', boardMember);
            }

            let boardArray = [];
            query.find().then(
                res => {
                    if (res.length !== 0) {
                        res.forEach(element => {
                            // 
                            this.getRelation(element).then(result => {
                                result.forEach(element => {
                                    // taskdetail = element.get('taskDetails');
                                    list.push({
                                        id: id,
                                        name: element.get('name'),
                                    });
                                });

                            });
                            let projectInfo = element.get('project').get('projectInfo');
                            boardArray.push({
                                id: element.id,
                                name: element.get('name'),
                                uri: element.get('uri'),
                                cards: taskdetail,
                                members: element.get('members'),
                                settings: element.get('settings'),
                                lists: list,
                                labels: element.get('labels'),
                                project: element.get('project'),
                                addOnType: projectInfo.addOnType === undefined ? '' : projectInfo.addOnType
                            });
                            this.boards = boardArray;
                            // 
                            this.onBoardsChanged.next(this.boards);
                            resolve(this.boards);
                        });
                    } else {
                        resolve(this.boards);
                    }
                },
                err => {
                    reject;
                }
            );

        });
    }

    async getRoleBasedBoard() {
        this.leaderProject = [];
        let project = [];
        let boardInstance = this.parseService.instance.Object.extend('ProjectMembers');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('status', 'Assigned');
        query.include('project');
        query.equalTo('user', { __type: 'Pointer', className: '_User', objectId: this.userId });
        await query.find().then(result => {
            result.forEach(element => {
                project.push(element.get('project').id);
            });
        });
        this.leaderProject = project;
        return this.leaderProject;
    }

    /**
     * Get board
     *
     * @param boardId
     * @returns {Promise<any>}
     */
    getBoard(boardId, active?): Promise<any> {
        let boardList = [
            { name: 'To Do', id: '', idCards: [] },
            { name: 'In-Progress', id: '', idCards: [] },
            { name: 'Completed', id: '', idCards: [] },
            { name: 'Ready for QA', id: '', idCards: [] },
            { name: 'Re-Open', id: '', idCards: [] },
            { name: 'Closed', id: '', idCards: [] }];

        let task = [];
        let list = [];
        return new Promise((resolve, reject) => {

            let boardInstance = this.parseService.instance.Object.extend('Sprint');
            let query = new this.parseService.instance.Query(boardInstance);

            query.include('project');

            // if (active != 'inActive') {
            //     query.equalTo('status', 'Active');
            query.notEqualTo('status', 'Closed');
            // }

            query.include('Tasks');
            query.equalTo('objectId', boardId);
            query.find().then(
                res => {
                    let board = {};
                    res.forEach(element => {
                        this.getRelation(element).then(result => {
                            result.forEach((element, index) => {
                                list.push({
                                    id: element.id,
                                    name: element.get('name'),
                                    idCards: []
                                });

                                this.getRelations(element).then(innerresult => {

                                    if (innerresult) {
                                        innerresult.forEach(innerelement => {

                                            let assignees = [];
                                            let assigneesId = [];
                                            list[index].idCards.push(innerelement.id);

                                            this.getRelationsAssignee(innerelement.get('assignee')).then(relationResult => {
                                                relationResult.forEach(res => {
                                                    assignees.push({
                                                        id: res.id,
                                                        username: res.get('username'),
                                                        image: res.get('profileImageInfo').url
                                                    });
                                                    assigneesId.push(res.id);

                                                });
                                            });

                                            task.push({
                                                id: innerelement.id,
                                                description: innerelement.get('description'),
                                                dueDate: innerelement.get('dueDate'),
                                                taskStatus: innerelement.get('userPlannedStatus'),
                                                startDate: innerelement.get('startDate'),
                                                comments: innerelement.get('comments'),
                                                attachments: innerelement.get('attachments'),
                                                activities: innerelement.get('activities'),
                                                idAttachmentCover: innerelement.get('idAttachmentCover'),
                                                title: innerelement.get('title'),
                                                taskCheckList: innerelement.get('taskCheckList'),
                                                priority: innerelement.get('priority'),
                                                taskRole: innerelement.get('taskRole'),
                                                taskType: innerelement.get('taskType'),
                                                estimatedHours: innerelement.get('estimatedHours'),
                                                completedHours: innerelement.get('completedHours'),
                                                estimatedHoursSecondsToHms: this.secondsToHms(innerelement.get('estimatedHours')),
                                                assignee: assignees,
                                                assigneesId: assigneesId,
                                                cardNumber: innerelement.get('cardNumber'),
                                                boardListId: innerelement.get('scrumboardList').id,
                                                boardListName: innerelement.get('scrumboardList').get('name'),
                                                taskBoardName: element.get('name'),
                                                typeOfTask: innerelement.get('typeOfTask'),
                                                storyPoints: innerelement.get('storyPoints'),
                                                cardType: innerelement.get('cardType'),
                                                todoDateActivity: innerelement.get('todoDateActivity'),
                                                inProgressDateActivity: innerelement.get('inProgressDateActivity'),
                                                completedDateActivity: innerelement.get('completedDateActivity'),
                                                readyForQaDateActivity: innerelement.get('readyForQaDateActivity'),
                                                reOpenDateActivity: innerelement.get('reOpenDateActivity'),
                                                closedDateActivity: innerelement.get('closedDateActivity'),
                                                createdAt: innerelement.get('createdAt')
                                            });
                                            this.board.cards = task
                                            this.board = board;
                                            this.onBoardChanged.next(this.board);
                                        });
                                    }
                                });
                            });

                            if (list.length === boardList.length) {
                                boardList.forEach(element => {
                                    list.filter(x => {
                                        if (x.name === element.name) {
                                            element.id = x.id,
                                                element.idCards = x.idCards;
                                        }
                                    });
                                });
                            }
                        }),
                            board = {
                                id: element.id,
                                name: element.get('name'),
                                uri: element.get('uri'),
                                cards: task,
                                members: element.get('members'),
                                settings: element.get('settings'),
                                lists: boardList,
                                labels: element.get('labels'),
                                project: element.get('project'),
                                lastCardNumber: element.get('lastCardNumber')
                            };
                        this.board = board;
                        this.onBoardChanged.next(this.board);
                    });

                    this.board = board;
                    this.onBoardChanged.next(this.board);
                    resolve(this.board);
                },
                err => {
                    reject;
                }
            );
        });
    }

    async updateBoardLists(boardList) {
        this.board.lists = boardList;
        await this.onBoardsChanged.next(this.boards)
    }


    async getRelation(result) {
        var relationResult = [];
        await result
            .relation('BoardLists')
            .query()
            .each(function (obj) {
                relationResult.push(obj);
            });
        return relationResult;
    }

    async getRelations(result) {
        var relationResult = [];
        await result
            .relation('Tasks')
            .query()
            .each(function (obj) {
                relationResult.push(obj);
            });
        return relationResult;
    }

    async getRelationsAssignee(result) {
        var relationResult = [];
        await result
            // .relation('Profile')
            .query()
            .each(function (obj) {
                relationResult.push(obj);
            });
        return relationResult;
    }

    /**
     * Add card
     *
     * @param listId
     * @param newCard
     * @returns {Promise<any>}
     */
    addCard(listId, newCard): Promise<any> {

        this.board.lists.map((list) => {
            if (list.id === listId) {
                return list.idCards.push(newCard.id);
            }
        });
        if (!this.board.cards) {
            this.board.cards = [];
        }
        this.board.cards.push(newCard);

        return this.updateBoard();
    }

    openTask(listId, newCard, boardId) {
        return new Promise<void>(async (resolve, reject) => {
            resolve();
        });
    }

    secondsToHms(d) {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        var hDisplay = (h <= 9 ? '0' : '') + h;
        var mDisplay = (m <= 9 ? '0' : '') + m;
        var sDisplay = (s <= 9 ? '0' : '') + s;
        return hDisplay + ':' + mDisplay;
    }

    async getBacklogRelations(result) {
        var relationResult = [];
        await result.query().each(function (obj) {
            relationResult.push(obj);
        });
        return relationResult;
    }

    async getAssignees(tasks) {
        let assignee = [];
        await tasks.query().each(innerElement => {
            assignee.push({
                name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
                profileId: innerElement.id,
                profilePic: innerElement.get('profileImageInfo').url
            });
        });
        return assignee;
    }


    /**
         * Add Task
         *
         * @param listId
         * @param newCard
         * @returns {Promise<any>}
         */

    async saveBacklogTask(listId, newCard, boardId): Promise<any> {
        let taskCheckList = [];
        return new Promise(async (resolve, reject) => {
            let dueDate = newCard.dueDate && newCard.dueDate != '' ? new Date(newCard.dueDate) : undefined;
            let startDate = newCard.startDate && newCard.startDate != '' ? new Date(newCard.startDate) : new Date();

            let taskClass = this.parseService.instance.Object.extend('Tasks');
            var taskDetail = new taskClass();
            if (dueDate) {
                taskDetail.set('dueDate', dueDate);
            }
            taskDetail.set('actualStartDate', startDate);
            taskDetail.set('startDate', startDate);
            taskDetail.set('isActive', true);
            taskDetail.set('title', newCard.name);
            taskDetail.set('userPlannedStatus', 'new');
            taskDetail.set('Project', {
                __type: 'Pointer',
                className: 'Project',
                objectId: boardId.project.id
            });
            taskDetail.set('taskCheckList', taskCheckList);
            taskDetail.set('sprintId', {
                __type: 'Pointer',
                className: 'Sprint',
                objectId: boardId.id
            });
            taskDetail.set('tenantId', this.tenantId);
            taskDetail.set('cardType', 'Backlog');
            taskDetail.set('description', newCard.description);
            taskDetail.set('comments', newCard.comments);
            taskDetail.set('taskRole', newCard.taskRole);
            taskDetail.set('taskType', newCard.taskType);
            taskDetail.set('typeOfTask', newCard.typeOfTask);
            taskDetail.set('attachments', newCard.attachments);
            taskDetail.set('priority', newCard.priority);
            taskDetail.set('activities', newCard.activities);
            taskDetail.set('idAttachmentCover', '');
            taskDetail.set('storyPoints', newCard.storyPoints);
            taskDetail.set('estimatedHours', newCard.estimatedHours !== '' ? newCard.estimatedHours : 0);
            taskDetail.set('completedHours', newCard.completedHours !== '' ? newCard.completedHours : 0);
            taskDetail.set('isAllocated', false);
            taskDetail.set('assigneesId', newCard.assigneesId);
            taskDetail.set('userPlannedStatus', 'new');
            taskDetail.set('scrumboardList', {
                __type: 'Pointer',
                className: 'ProjectBoardLists',
                objectId: listId
            });
            taskDetail.set('cardNumber', Number(this.board.lastCardNumber + 1));

            taskDetail.set('taskUpdatedTime', newCard.taskUpdatedTime);
            taskDetail.set('todoDateActivity', newCard.todoDateActivity);
            taskDetail.set('inProgressDateActivity', newCard.inProgressDateActivity);
            taskDetail.set('completedDateActivity', newCard.completedDateActivity);
            taskDetail.set('readyForQaDateActivity', newCard.readyForQaDateActivity);
            taskDetail.set('reOpenDateActivity', newCard.reOpenDateActivity);
            taskDetail.set('closedDateActivity', newCard.closedDateActivity);

            taskDetail.save().then(async (taskDetail) => {
                resolve(taskDetail);
                this.taskId = taskDetail.id;
                this.toastr.success('Task created Successfully');
                this.setNewCardNumber(taskDetail, boardId, listId);
                await this.taskBoardRelation(taskDetail.get('Project').objectId, taskDetail.id);
                this.taskSprintRelation(taskDetail, taskDetail.get('Project').objectId);
            }, (error) => {
                alert('Failed to create new object, with error code: ' + error.message);
            });
        });
    }

    async taskBoardRelation(projectId, taskId) {
        let boardInstance = this.parseService.instance.Object.extend('ProjectBoardLists');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('project', {
            __type: 'Pointer',
            className: 'Project',
            objectId: projectId
        });
        await query.find().then(results => {
            let task = JSON.parse(JSON.stringify(results));
            let todo = task.find(x => x.name == 'Backlogs');
            var currentTodo = results.find(x => x.id == todo.objectId);
            var queryProfile = new this.parseService.instance.Object('Tasks');
            queryProfile.id = taskId;
            var relation = currentTodo.relation('Tasks');
            relation.add(queryProfile);

            currentTodo.save().then((currentTodo) => {
                // alert('New object created with objectId: ' + currentTodo.id);
            }, (error) => {
                alert('Failed to create new object, with error code: ' + error.message);
            });
        });
    }


    setNewCardNumber(taskDetail, boardId, listId) {
        this.taskId = taskDetail.id;

        let card = JSON.parse(JSON.stringify(taskDetail));
        card['id'] = card.objectId;
        card.dueDate = new Date();
        delete card.objectId;
        delete card.isActive;
        delete card.createdAt;
        delete card.updatedAt;
        this.board.cards.push(card);
        this.board.lastCardNumber = taskDetail.get('cardNumber')
        this.board.lists.map((list) => {
            if (list.id === listId) {
                return list.idCards.push(taskDetail.id);
            }
        });
        this.onBoardChanged.next(this.board);

        let boardInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('objectId', this.board.id);
        query.find()
            .then(function (results) {
                if (results.length > 0) {
                    let boardDetails = results[0];
                    boardDetails.set('lastCardNumber', taskDetail.get('cardNumber'));
                    boardDetails.save().then(res => {
                    });
                }
            })
    }

    async getCardNumber(boardId) {
        let boardInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('project', {
            __type: 'Pointer',
            className: 'Project',
            objectId: boardId.project.id
        });
        query.equalTo('name', 'Backlogs');
        await query.find().then(results => {
            this.cardNumber = (results[0].get('lastCardNumber'));
        });
    }

    /**
         * Add Task
         *
         * @param listId
         * @param newCard
         * @returns {Promise<any>}
         */

    saveTask(listId, newCard, boardId): Promise<any> {
        let taskCheckList = [];
        return new Promise(async (resolve, reject) => {
            let dueDate = newCard.due && newCard.due != '' ? new Date(newCard.due) : new Date();
            let startDate = newCard.startDate && newCard.startDate != '' ? new Date(newCard.startDate) : new Date();

            await this.getCardNumber(boardId);

            let taskClass = this.parseService.instance.Object.extend('Tasks');
            var taskDetail = new taskClass();
            taskDetail.set('dueDate', dueDate);
            taskDetail.set('startDate', startDate);
            taskDetail.set('isActive', true);
            taskDetail.set('title', newCard.name);
            taskDetail.set('Project', { __type: 'Pointer', className: 'Project', objectId: boardId.project.id });
            taskDetail.set('taskCheckList', taskCheckList);
            taskDetail.set('sprintId', { __type: 'Pointer', className: 'Sprint', objectId: boardId.id });

            var queryProfile = new this.parseService.instance.Object('Sprint');
            queryProfile.id = boardId.id;
            let chartData = queryProfile.get('chartData');
            chartData.tasks.unPlanned.total = chartData.tasks.unPlanned.total + 1;
            chartData.tasks.unPlanned.remaining = chartData.tasks.unPlanned.remaining + 1;
            queryProfile.set('chartData', chartData)
            queryProfile.save();

            taskDetail.set('description', newCard.description);
            taskDetail.set('comments', newCard.comments);
            taskDetail.set('taskRole', newCard.taskRole);
            taskDetail.set('taskType', newCard.taskType);
            taskDetail.set('typeOfTask', newCard.typeOfTask);
            taskDetail.set('attachments', newCard.attachments);
            taskDetail.set('priority', newCard.priority);
            taskDetail.set('activities', newCard.activities);
            taskDetail.set('cardType', 'UnPlanned');
            taskDetail.set('idAttachmentCover', '');
            taskDetail.set('storyPoints', '');
            taskDetail.set('estimatedHours', 0);
            taskDetail.set('completedHours', 0);
            taskDetail.set('isAllocated', false);
            taskDetail.set('assigneesId', newCard.assigneesId);
            taskDetail.set('scrumboardList', { __type: 'Pointer', className: 'ProjectBoardLists', objectId: listId });
            // taskDetail.set('cardNumber', Number(this.board.lastCardNumber + 1));
            taskDetail.set('cardNumber', Number(this.cardNumber + 1));

            newCard.taskUpdatedTime.todoDate = new Date().toISOString();
            taskDetail.set('taskUpdatedTime', newCard.taskUpdatedTime);
            let activityTodo = [];
            activityTodo.push({ date: newCard.taskUpdatedTime.todoDate, movedCount: 1 });
            newCard.todoDateActivity = activityTodo;
            taskDetail.set('todoDateActivity', newCard.todoDateActivity);
            taskDetail.set('inProgressDateActivity', newCard.inProgressDateActivity);
            taskDetail.set('completedDateActivity', newCard.completedDateActivity);
            taskDetail.set('readyForQaDateActivity', newCard.readyForQaDateActivity);
            taskDetail.set('reOpenDateActivity', newCard.reOpenDateActivity);
            taskDetail.set('closedDateActivity', newCard.closedDateActivity);

            taskDetail.save().then((taskDetail) => {
                this.taskId = taskDetail.id;
                this.toastr.success('Task created Successfully');
                this.setCardNumber(taskDetail, boardId, listId);
                this.setBacklogCardNumber(taskDetail, boardId)
                this.sprintRelationAdd(taskDetail, boardId.id);
            }, (error) => {
                alert('Failed to create new object, with error code: ' + error.message);
            });
        });
    }

    setBacklogCardNumber(taskDetail, boardId) {
        let boardInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('project', {
            __type: 'Pointer',
            className: 'Project',
            objectId: boardId.project.id
        });
        query.equalTo('name', 'Backlogs');
        query.find().then(function (results) {
            if (results.length > 0) {
                let boardDetails = results[0];
                boardDetails.set('lastCardNumber', taskDetail.get('cardNumber'));
                boardDetails.save().then(res => {
                });
            }
        })
    }

    setCardNumber(taskDetail, boardId, listId) {
        this.taskId = taskDetail.id;
        this.taskRelation(boardId);

        let card = JSON.parse(JSON.stringify(taskDetail));
        card['id'] = card.objectId;
        card.dueDate = new Date();
        delete card.objectId;
        delete card.isActive;
        delete card.createdAt;
        delete card.updatedAt;
        this.board.cards.push(card);
        this.board.lastCardNumber = taskDetail.get('cardNumber')
        this.board.lists.map((list) => {
            if (list.id === listId) {
                return list.idCards.push(taskDetail.id);
            }
        });
        this.onBoardChanged.next(this.board);

        let boardInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('objectId', this.board.id);
        query.find()
            .then(function (results) {
                if (results.length > 0) {
                    let boardDetails = results[0];
                    boardDetails.set('lastCardNumber', taskDetail.get('cardNumber'));
                    boardDetails.save().then(res => {
                    });
                }
            })
    }

    taskRelation(boardId) {
        let boardInstance = this.parseService.instance.Object.extend('ProjectBoardLists');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('project', {
            __type: 'Pointer',
            className: 'Project',
            objectId: boardId.project.id
        });
        query.find().then(results => {
            let task = JSON.parse(JSON.stringify(results));
            let todo = task.find(x => x.name == 'To Do');
            var currentTodo = results.find(x => x.id == todo.objectId);
            var queryProfile = new this.parseService.instance.Object('Tasks');
            queryProfile.id = this.taskId;
            var relation = currentTodo.relation('Tasks');
            relation.add(queryProfile);

            currentTodo.save().then((currentTodo) => {
                // alert('New object created with objectId: ' + currentTodo.id);
            }, (error) => {
                alert('Failed to create new object, with error code: ' + error.message);
            });
        });
    }

    async sprintRelationAdd(taskId, sprintId) {
        let queryInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', sprintId);
        await query.find().then(async res => {
            let result = res[0];
            let taskRelation = result.relation('tasks');
            taskRelation.add(taskId);
            result.save()
        });
        let queryTasksInstance = this.parseService.instance.Object.extend('Tasks');
        let queryTasks = new this.parseService.instance.Query(queryTasksInstance);
        queryTasks.include('scrumboardList');
        queryTasks.equalTo('objectId', taskId.id);
        await queryTasks.find().then(res => {
            let boardList = res[0].get('scrumboardList');
            let boardListTaskRelation = boardList.relation('Tasks');
            boardListTaskRelation.add(taskId);
            res[0].save()
        });
    }

    addCardTaskRelation(assigneesId, cardId): Promise<any> {
        let assignees = [];
        let assigned = [];
        return new Promise(async (resolve, reject) => {
            let queryInstance = this.parseService.instance.Object.extend('Tasks');
            let query = new this.parseService.instance.Query(queryInstance);
            query.equalTo('objectId', cardId);
            query.find().then(result => {
                let res = result[0];
                var queryProfile = new this.parseService.instance.Object('Profile');
                queryProfile.id = assigneesId;
                var relation = res.relation('assignee');
                relation.add(queryProfile);
                res.save().then(async (task) => {
                    await this.getRelationsAssignee(task.get('assignee')).then(result => {
                        this.currentAssignees = result;
                    });
                    this.currentAssignees.forEach(element => {
                        assignees.push({
                            id: element.id,
                            username: element.get('username'),
                            image: element.get('profileImageInfo').url
                        });
                    });
                    this.board.cards.forEach(x => {
                        if (x.id == res.id) {
                            x.assignee = assignees;
                            assignees.forEach(element => {
                                assigned.push(element.id);
                                x.assigneesId = assigned;
                            });
                        }
                    });
                    this.onBoardChanged.next(this.board);
                    resolve(this.board);
                }, function (error) {
                });
            });
        });
    }

    // updateScrumboard(projectId, projectValue): Promise<any> {
    //     return new Promise((resolve, reject) => {
    //         this.queryInterface.executeQuery(this.parseService, 'Scrumboard', [{
    //             condition: 'equalTo', field: 'project',
    //             value: {
    //                 __type: 'Pointer',
    //                 className: 'Project',
    //                 objectId: projectId
    //             }
    //         }]).then(result => {
    //             var results = result[0];
    //             results.set('isActive', projectValue.projectInfo.currentStatus !== 'Archived');
    //             results.set('name', projectValue.projectInfo.projectName);
    //             results.save().then(res => {
    //                 resolve(res[0]);
    //             }, reject);
    //         });
    //     });
    // }

    createScrumboardSprint(project, formValue, status): Promise<any> {
        this.projectId = project.id;
        project = JSON.parse(JSON.stringify(project))
        return new Promise(async (resolve, reject) => {
            this.storyPoints.planned.completed = 0;
            this.storyPoints.planned.remaining = 0;
            this.storyPoints.planned.total = 0;
            this.storyPoints.unPlanned.completed = 0;
            this.storyPoints.unPlanned.remaining = 0;
            this.storyPoints.unPlanned.total = 0;
            this.storyPoints.previousSprint.completed = 0;
            this.storyPoints.previousSprint.remaining = 0;
            this.storyPoints.previousSprint.total = 0;
            this.storyPoints.movedToBacklogs = 0;

            this.tasks.planned.completed = 0;
            this.tasks.planned.remaining = 0;
            this.tasks.planned.total = 0;
            this.tasks.unPlanned.completed = 0;
            this.tasks.unPlanned.remaining = 0;
            this.tasks.unPlanned.total = 0;
            this.tasks.previousSprint.completed = 0;
            this.tasks.previousSprint.remaining = 0;
            this.tasks.previousSprint.total = 0;
            this.tasks.movedToBacklogs = 0;

            this.hours.planned.completed = 0;
            this.hours.planned.remaining = 0;
            this.hours.planned.total = 0;
            this.hours.unPlanned.completed = 0;
            this.hours.unPlanned.remaining = 0;
            this.hours.unPlanned.total = 0;
            this.hours.previousSprint.completed = 0;
            this.hours.previousSprint.remaining = 0;
            this.hours.previousSprint.total = 0;
            this.hours.movedToBacklogs = 0;

            let newChartData = { storyPoints: this.storyPoints, tasks: this.tasks, hours: this.hours }
            let Scrumboard = this.parseService.instance.Object.extend('Sprint');
            var scrumBoard = new Scrumboard();
            scrumBoard.set('settings', { color: '', subscribed: true, cardCoverImages: true });
            scrumBoard.set('lastCardNumber', 1000);
            scrumBoard.set('name', formValue.sprintName);
            scrumBoard.set('uri', formValue.sprintName);
            scrumBoard.set('startDate', formValue.startDate._d);
            scrumBoard.set('endDate', formValue.endDate._d);
            scrumBoard.set('status', status);
            scrumBoard.set('sprintGoal', formValue.sprintGoal);
            scrumBoard.set('isActive', true);
            scrumBoard.set('chartData', newChartData);
            scrumBoard.set('project', {
                __type: 'Pointer',
                className: 'Project',
                objectId: project.id === undefined ? project.objectId : project.id
            });
            scrumBoard.save().then(res => {
                this.creatBoardList(res);
                resolve(res);
            });
        });
    }

    randomStr(len, arr) {
        var ans = '';
        for (var i = len; i > 0; i--) {
            ans +=
                arr[Math.floor(Math.random() * arr.length)];
        }
        return ans;
    }

    taskSprintRelation(task, projectId) {
        let queryInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(queryInstance);
        query.include('project');
        query.equalTo('project', {
            __type: 'Pointer',
            className: 'Project',
            objectId: projectId
        });
        query.equalTo('name', 'Backlogs');
        query.first().then(function (res) {
            var relation = res.relation('tasks');
            relation.add(task);
            res.save().then(result => {
            });
            return res;
        });
    }

    async createScrumBoard(project, toaster?): Promise<any> {
        this.projectId = project;
        project = JSON.parse(JSON.stringify(project))
        return new Promise(async (resolve, reject) => {
            let Scrumboard = this.parseService.instance.Object.extend('Sprint');
            var scrumBoard = new Scrumboard();
            let projectInfo = project.projectInfo

            scrumBoard.set('settings', { color: '', subscribed: true, cardCoverImages: true });
            scrumBoard.set('lastCardNumber', 1000);
            scrumBoard.set('startDate', new Date());
            // if (projectInfo.projectEndDate != undefined) {
            scrumBoard.set('endDate', new Date());
            // }
            scrumBoard.set('isActive', true);
            scrumBoard.set('name', 'Backlogs');
            scrumBoard.set('uri', 'Backlogs');
            scrumBoard.set('status', 'New');
            scrumBoard.set('sprintGoal', '');
            scrumBoard.set('chartData', {});
            scrumBoard.set('project', {
                __type: 'Pointer',
                className: 'Project',
                objectId: project === undefined ? project : project
            });
            let data = await scrumBoard.save();
            await this.creatBoardList(data, toaster);
            return resolve(data);
        });
    }

    async getScrumboarList(projectId, boardId) {
        let scrumboardList = [];
        let results = []
        let boardList = this.parseService.instance.Object.extend('ProjectBoardLists');
        let query = new this.parseService.instance.Query(boardList);
        query.equalTo('project', {
            __type: 'Pointer',
            className: 'Project',
            objectId: projectId
        });
        query.equalTo('objectId', boardId);
        await query.find().then(result => {
            result.forEach(element => {
                let index = results.indexOf({ boardId: element.id, boardName: element.get('name') });
                if (index == -1) {
                    results.push({ boardId: element.id, boardName: element.get('name') });
                }
            });

        });
        scrumboardList = results;
        return scrumboardList;
    }

    uniqBy(a, key) {
        var index = [];
        return a.filter(function (item) {
            var k = key(item);
            return index.indexOf(k) >= 0 ? false : index.push(k);
        });
    }

    async getBoardList() {
        this.boardList = [];
        let boards = [];
        let boardInstance = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(boardInstance);
        await query.find().then(results => {
            let result = results[0];
            this.boardList = result.get('boardList');
            boards = this.boardList
        });
        return boards;
    }

    async creatBoardList(res, toaster?) {
        toaster === undefined ? toaster = true : '';
        let sprintName = res.get('name');
        await this.getBoardList();
        if ((res.get('name')) == 'Backlogs') {
            this.boardList.push({
                name: 'Backlogs'
            });
        }
        let boardInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('objectId', res.id);
        query.find().then(result => {
            let scrumBoard = result[0];
            this.boardList.forEach(element => {
                let boardList = this.parseService.instance.Object.extend('ProjectBoardLists');
                let board = new boardList();
                board.set('name', element.name);
                board.set('project', {
                    __type: 'Pointer',
                    className: 'Project',
                    objectId: this.projectId
                });
                board.save().then(res => {
                    var queryProfile = new this.parseService.instance.Object('ProjectBoardLists');
                    queryProfile.id = res.id;
                    let relation = scrumBoard.relation('BoardLists');
                    relation.add(queryProfile);
                    scrumBoard.save();
                    if (toaster) {
                        if (sprintName != 'Backlogs') {
                            this.toastr.success('Phase Created Successfully!');
                        }
                        else {
                            // this.toastr.success('Backlogs Created Successfully!');
                        }
                    }
                });
            });
        });
    }

    /**
     * Add list
     *
     * @param newList
     * @returns {Promise<any>}
     */
    addList(newList): Promise<any> {
        if (!this.board.lists) {
            this.board.lists = [];
        }
        this.board.lists.push(newList);
        return this.updateBoard();
    }

    updateList(editList): Promise<any> {
        this.board.lists.map((_list) => {
            if (_list.id === editList.id) {
                return editList;
            }
        });
        return this.updateBoard();
    }

    /**
     * Remove list
     *
     * @param listId
     * @returns {Promise<any>}
     */
    removeList(listId): Promise<any> {
        const list = this.board.lists.find((_list) => {
            return _list.id === listId;
        });
        for (const cardId of list.idCards) {
            this.removeCard(cardId);
        }

        const index = this.board.lists.indexOf(list);
        this.board.lists.splice(index, 1);
        return this.updateBoard();
    }

    /**
     * Remove card
     *
     * @param cardId
     * @param listId
     */
    removeCard(cardId, listId?): void {
        const card = this.board.cards.find((_card) => {
            return _card.id === cardId;
        });

        if (listId) {
            const list = this.board.lists.find((_list) => {
                return listId === _list.id;
            });
            list.idCards.splice(list.idCards.indexOf(cardId), 1);
        }

        this.board.cards.splice(this.board.cards.indexOf(card), 1);

        this.removeTasks(cardId);
        this.updateBoard();
    }

    removeTasks(event) {
        this.queryInterface.executeQuery(this.parseService, 'Tasks', [
            { condition: 'equalTo', field: 'objectId', value: event },]).then(async result => {
                let task = result[0];
                task.destroy();
            });
    }

    /**
     * Update board
     *
     * @returns {Promise<any>}
     */
    updateBoard(): Promise<any> {
        return new Promise((resolve, reject) => {
            let boardInstance = this.parseService.instance.Object.extend('Sprint');
            let query = new this.parseService.instance.Query(boardInstance);
            query.equalTo('objectId', this.board.id);
            query.find().then(function (results) {
                if (results.length > 0) {
                    let boardDetails = results[0];

                    boardDetails.set('name', this.board.name),
                        boardDetails.set('uri', this.board.uri),
                        boardDetails.set('settings', this.board.settings),
                        // boardDetails.set('lists', this.board.lists),

                        boardDetails.save().then(res => {
                            this.toastr.success('Board Updated Successfully');
                            this.onBoardChanged.next(this.board);
                            resolve(this.board);
                        });
                } else {
                    this.toastr.success('No Board Found');
                }
            }.bind(this)).catch(function (error) {
            });
        });
    }

    /**
        * Update card
        *
        * @param newCard
        */
    updateCard(newCard): void {

        this.board.cards.map((_card) => {
            if (_card.id === newCard.id) {
                return newCard;
            }
        });
        this.updateTasks(newCard, '', '', '', '');
        // this.updateBoard();
    }

    /**
     * Update board
     * @param newCard
     * @returns {Promise<any>}
     */
    updateTasks(newCard, assigneesId, milestoneId, oldMilestoneId, attachments, isWebTask?): Promise<any> {

        return new Promise((resolve, reject) => {
            let assignees = [];

            let startDate = new Date(newCard.startDate.iso != undefined ? newCard.startDate.iso : newCard.startDate);
            // let startDate = this.dateConvertor.addGMTOffset(new Date(new Date(newCard.startDate).setHours(6))).toISOString();

            const boardInstance = this.parseService.instance.Object.extend('Tasks');
            let query = new this.parseService.instance.Query(boardInstance);
            query.equalTo('objectId', newCard.id);
            query.find().then(async (results) => {
                if (results.length > 0) {
                    let taskDetail = results[0];
                    if (newCard.dueDate) {
                        let date = new Date(newCard.dueDate);
                        taskDetail.set('dueDate', date);
                    }
                    if (newCard.startDate != undefined && newCard.startDate != 'Invalid Date') {
                        taskDetail.set('startDate', startDate);
                    }
                    taskDetail.set('title', newCard.title);
                    taskDetail.set('storyPoints', newCard.storyPoints);
                    taskDetail.set('comments', newCard.comments);
                    taskDetail.set('description', newCard.description);
                    taskDetail.set('taskCheckList', newCard.taskCheckList);
                    taskDetail.set('taskRole', newCard.taskRole);
                    taskDetail.set('taskType', newCard.taskType);
                    // taskDetail.set('typeOfTask', newCard.typeOfTask);
                    taskDetail.set('typeOfTask', newCard.taskType);
                    if (newCard.boardListId != undefined) {
                        taskDetail.set('scrumboardList', { __type: 'Pointer', className: 'ProjectBoardLists', objectId: newCard.boardListId });
                    }
                    else {
                        taskDetail.set('scrumboardList', { __type: 'Pointer', className: 'ProjectBoardLists', objectId: newCard.scrumboardList.objectId });
                    }

                    if (attachments.length > 0) {
                        taskDetail.set('attachments', attachments);
                    }
                    taskDetail.set('attachments', newCard.attachments);
                    taskDetail.set('idAttachmentCover', newCard.idAttachmentCover);
                    taskDetail.set('priority', newCard.priority);
                    taskDetail.set('activities', newCard.activities);
                    taskDetail.set('estimatedHours', newCard.estimatedHours);
                    taskDetail.set('completedHours', newCard.completedHours);
                    taskDetail.set('assigneesId', newCard.assigneesId);
                    taskDetail.set('tenantId', this.tenantId);
                    taskDetail.set('userPlannedStatus', isWebTask ? newCard.taskStatus : 'new');

                    if (assigneesId) {
                        assigneesId.forEach(element => {
                            var queryProfile = new this.parseService.instance.Object('Profile');
                            queryProfile.id = element;
                            var relation = taskDetail.relation('assignee');
                            relation.add(queryProfile);
                        });
                    }

                    taskDetail.save().then(async res => {
                        // this.getListOfBacklogTasks(res.get('Project').id);
                        this.toastr.success('Task Updated Successfully');
                        /**
                         * * below condition is used when task update from the my task page
                         */
                        if (isWebTask) {
                            resolve(this.board);
                        }
                        await this.getRelationsAssignee(res.get('assignee')).then(result => {
                            this.currentAssignees = result;
                        });
                        this.currentAssignees.forEach(element => {
                            assignees.push({
                                id: element.id,
                                username: element.get('username'),
                                image: element.get('profileImageInfo').url ? element.get('profileImageInfo').url : ''
                            });
                        });
                        this.board.cards.forEach(x => {

                            if (x.id == res.id) {
                                x.assignee = assignees;
                            }
                        });
                        this.onBoardChanged.next(this.board);
                        resolve(this.board);
                    });
                }
            });
        });
    }

    removeCardTaskRelation(assigneesId, cardId): Promise<any> {
        return new Promise(async (resolve, reject) => {
            let queryInstance = this.parseService.instance.Object.extend('Tasks');
            let query = new this.parseService.instance.Query(queryInstance);
            query.equalTo('objectId', cardId);
            query.find().then(result => {
                let res = result[0];
                var queryProfile = new this.parseService.instance.Object('Profile');
                queryProfile.id = assigneesId;
                var relation = res.relation('assignee');
                relation.remove(queryProfile);
                res.save().then((result) => {
                    this.board.cards.forEach(element => {
                        if (element.id == result.id) {
                            let assignee = element.assignee.findIndex(x => x.id == assigneesId);
                            element.assignee.splice(assignee, 1);
                            element.assigneesId.splice(assignee, 1);
                        }
                    });
                    this.onBoardChanged.next(this.board);
                    resolve(this.board);
                }, function (error) {
                });
            });
        });
    }

    boardSearch(boardName): Promise<any> {
        let taskdetail;
        let list = [];
        let boardMember = [];
        return new Promise(async (resolve, reject) => {

            let boardInstance = this.parseService.instance.Object.extend('Scrumboard');
            let query = new this.parseService.instance.Query(boardInstance);
            query.descending('createdAt');
            query.include('project');
            query.equalTo('isActive', true);
            if (boardName != '') {
                query.startsWith('name', boardName);
            }
            if (this.empRole != 'Admin') {
                boardMember = await this.getRoleBasedBoard();
                query.containedIn('project', boardMember);
            }

            query.find().then(res => {
                let boardArray = [];
                if (res.length !== 0) {
                    res.forEach(element => {

                        this.getRelation(element).then(result => {
                            result.forEach(element => {
                                list.push({
                                    id: id,
                                    name: element.get('name'),
                                });
                            });

                        });
                        let projectInfo = element.get('project').get('projectInfo');

                        boardArray.push({
                            id: element.id,
                            name: element.get('name'),
                            uri: element.get('uri'),
                            cards: taskdetail,
                            members: element.get('members'),
                            settings: element.get('settings'),
                            lists: list,
                            labels: element.get('labels'),
                            project: element.get('project'),
                            addOnType: projectInfo.addOnType === undefined ? '' : projectInfo.addOnType
                        });
                        this.boards = boardArray;
                        this.onBoardsChanged.next(this.boards);
                        resolve(this.boards);
                    });
                } else {
                    this.boards = [];
                    this.onBoardsChanged.next(this.boards);
                    resolve(this.boards);
                }
            }), err => {
                reject;
            }
        });
    }

    cardOut(card) {
        this.board.lists.forEach(element => {
            const selected = element.idCards.includes(card);
            if (selected) {
                this.taskFrom = element.name;
                this.taskFromId = element.id;
            }
        });
        let dataSettings = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(dataSettings);
        query.find().then(results => {
            if (this.boardRule.length == 0) {
                this.boardRule = results[0].get('boardRule');
            }
        });
    }

    async dropCard(card) {
        let dropRejected = false;
        let scrumboardListId = '';
        await this.checkTaskStatus(card).then(data => {
            scrumboardListId = data;
        });
        if (this.taskFromId == scrumboardListId) {
            this.board.lists.forEach(async element => {
                const selected = element.idCards.includes(card);
                if (selected) {
                    this.taskTo = element.name;
                    if (this.taskTo != this.taskFrom) {
                        let task = new this.parseService.instance.Object('Tasks');
                        task.id = card;
                        this.removeTaskRelation(task, this.taskFromId);
                    }
                    let listRule = this.boardRule.filter(x => x.from == this.taskFrom);
                    let acceptedLists = listRule[0].to;
                    acceptedLists.forEach(innerElement => {
                        if (innerElement == this.taskTo) {
                            this.acceptedListName = innerElement;
                        }
                    });

                    if (this.taskTo == this.acceptedListName) {
                        this.taskToId = element.id;

                        let completedHours;
                        let estimatedHours;
                        let query = new this.parseService.instance.Object('Tasks');
                        query.id = card;
                        completedHours = query.get('completedHours');
                        estimatedHours = query.get('estimatedHours');

                        if ((this.taskTo == 'Completed' || this.taskTo == 'Ready for QA' || this.taskTo == 'Closed') && completedHours == 0) {
                            this.toastr.warning('Please enter the completed hours');
                            dropRejected = true;
                        }
                        if ((this.taskTo == 'In-Progress') && estimatedHours == 0) {
                            this.toastr.warning('Please enter the estimated hours');
                            dropRejected = true;
                        }
                        else {
                            this.cardChange(element, card);
                        }

                    } else {
                        dropRejected = true;
                        let possibility = acceptedLists.join();
                        let message = "Allowed lists are " + possibility;
                        this.toastr.warning(message);
                    }

                }
            });
        }
        else {
            this.toastr.warning('Already task status has been updated, please do refresh');
            this.confirmDialogRef = this._matDialog.open(ScrumboardConfirmDialogComponent, {
                disableClose: false
            });
            this.confirmDialogRef.componentInstance.confirmMessage = 'Already task status has been updated, Are you sure you want to refresh?';
            this.confirmDialogRef.afterClosed().subscribe(result => {
                if (result) {
                    window.location.reload();
                }
            });
        }
        if (dropRejected) {
            this.board.lists.forEach(list => {
                if (this.taskTo == list.name) {
                    let cardIndex = list.idCards.indexOf(card);
                    list.idCards.splice(cardIndex, 1);
                }
                if (this.taskFrom == list.name) {
                    list.idCards.unshift(card);
                    this.taskToId = list.id;
                    this.cardChange(list, card);
                }
            })
            this.taskTo = this.taskFrom;
        }
    }

    cardChange(list, card): Promise<any> {
        return new Promise((resolve, reject) => {

            const boardInstance = this.parseService.instance.Object.extend('ProjectBoardLists');
            let query = new this.parseService.instance.Query(boardInstance);
            query.equalTo('objectId', list.id);
            query.find().then(async results => {
                let result = results[0];
                let taskList = [];
                await result
                    .relation('Tasks')
                    .query()
                    .each(function (obj) {
                        taskList.push(obj);
                    });
                list.idCards.forEach(element => {
                    let task = new this.parseService.instance.Object('Tasks');
                    task.id = element;
                    this.addTaskRelation(task, list.id);
                });
                if (this.taskFrom !== this.taskTo) {

                    const taskInstance = this.parseService.instance.Object.extend('Tasks');
                    let query = new this.parseService.instance.Query(taskInstance);
                    query.equalTo('objectId', card);
                    query.find().then(results => {
                        let result = results[0];
                        let activities = [];
                        activities = result.get('activities');
                        const createrProfile = this.currentUser.get('profile');
                        const createrImg = createrProfile.get('profileImageInfo').url;
                        const createrName = createrProfile.get('username');

                        result = this.updateChartData(result);

                        const activity = {
                            message: 'Card Changed from ' + this.taskFrom + ' to ' + this.taskTo,
                            createdBy: createrName,
                            createdId: createrProfile.id,
                            createdDate: new Date().toUTCString(),
                            createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
                        };
                        activities.unshift(activity);
                        result.set('activities', activities);
                        result.set('scrumboardList', { __type: 'Pointer', className: 'ProjectBoardLists', objectId: this.taskToId });

                        result.save().then(res => {
                            this.board.cards.forEach(element => {
                                if (element.id === res.id) {
                                    element.activities = res.get('activities');
                                    element.scrumboardList = res.get('scrumboardList');
                                    element.boardListId = this.taskToId;
                                    element.boardListName = this.taskTo;
                                    element.todoDateActivity = res.get('todoDateActivity');
                                    element.inProgressDateActivity = res.get('inProgressDateActivity');
                                    element.completedDateActivity = res.get('completedDateActivity');
                                    element.readyForQaDateActivity = res.get('readyForQaDateActivity');
                                    element.reOpenDateActivity = res.get('reOpenDateActivity');
                                    element.closedDateActivity = res.get('closedDateActivity');
                                }
                            });
                            this.toastr.success('Board Updated Successfully');
                            this.onBoardChanged.next(this.board);
                            resolve(this.board);
                        });
                    });
                }
            });
        });
    }

    async checkTaskStatus(taskId) {
        let taskListId = '';
        const boardInstance = this.parseService.instance.Object.extend('Tasks');
        let query = new this.parseService.instance.Query(boardInstance);
        query.equalTo('objectId', taskId);
        query.include('scrumboardList');
        await query.find().then(async results => {
            taskListId = results[0].get('scrumboardList').id;
        });
        return taskListId;
    }

    updateChartData(result) {
        let taskUpdatedTime = result.get('taskUpdatedTime');
        let movedCount = 0;

        switch (this.taskTo) {
            case "To Do":
                taskUpdatedTime.todoDate = new Date().toISOString();
                let todoDateActivity = result.get('todoDateActivity');
                movedCount = todoDateActivity.length > 0 ? todoDateActivity[todoDateActivity.length - 1].movedCount : movedCount;
                todoDateActivity.push({ date: taskUpdatedTime.todoDate, movedCount: movedCount + 1 })
                result.set('todoDateActivity', todoDateActivity);
                break;
            case "In-Progress":
                taskUpdatedTime.inProgressDate = new Date().toISOString();
                let inProgressDateActivity = result.get('inProgressDateActivity');
                movedCount = inProgressDateActivity.length > 0 ? inProgressDateActivity[inProgressDateActivity.length - 1].movedCount : movedCount;
                inProgressDateActivity.push({ date: taskUpdatedTime.inProgressDate, movedCount: movedCount + 1 })
                result.set('inProgressDateActivity', inProgressDateActivity);
                break;
            case "Completed":
                taskUpdatedTime.completedDate = new Date().toISOString();
                let completedDateActivity = result.get('completedDateActivity');
                movedCount = completedDateActivity.length > 0 ? completedDateActivity[completedDateActivity.length - 1].movedCount : movedCount;
                completedDateActivity.push({ date: taskUpdatedTime.completedDate, movedCount: movedCount + 1 })
                result.set('completedDateActivity', completedDateActivity);
                break;
            case "Ready for QA":
                taskUpdatedTime.readyForQaDate = new Date().toISOString();
                let readyForQaDateActivity = result.get('readyForQaDateActivity');
                movedCount = readyForQaDateActivity.length > 0 ? readyForQaDateActivity[readyForQaDateActivity.length - 1].movedCount : movedCount;
                readyForQaDateActivity.push({ date: taskUpdatedTime.readyForQaDate, movedCount: movedCount + 1 })
                result.set('readyForQaDateActivity', readyForQaDateActivity);
                break;
            case "Re-Open":
                taskUpdatedTime.reOpenDate = new Date().toISOString();
                let reOpenDateActivity = result.get('reOpenDateActivity');
                movedCount = reOpenDateActivity.length > 0 ? reOpenDateActivity[reOpenDateActivity.length - 1].movedCount : movedCount;
                reOpenDateActivity.push({ date: taskUpdatedTime.reOpenDate, movedCount: movedCount + 1 })
                result.set('reOpenDateActivity', reOpenDateActivity);
                break;
            case "Closed":
                taskUpdatedTime.closedDate = new Date().toISOString();
                let closedDateActivity = result.get('closedDateActivity');
                movedCount = closedDateActivity.length > 0 ? closedDateActivity[closedDateActivity.length - 1].movedCount : movedCount;
                closedDateActivity.push({ date: taskUpdatedTime.closedDate, movedCount: movedCount + 1 })
                result.set('closedDateActivity', closedDateActivity);

                const sprintInstance = new this.parseService.instance.Object('Sprint');
                sprintInstance.id = this.board.id;
                let storyPoints = result.get('storyPoints');
                storyPoints = storyPoints != '' ? Number(storyPoints) : 0;
                let chartData = sprintInstance.get('chartData');
                let completedHours = result.get('completedHours');
                let cardType = result.get('cardType');
                switch (cardType) {
                    case 'Planned':
                        chartData.storyPoints.planned.completed = chartData.storyPoints.planned.completed + storyPoints;
                        chartData.tasks.planned.completed = chartData.tasks.planned.completed + 1;
                        chartData.hours.planned.completed = chartData.hours.planned.completed + completedHours;
                        chartData.storyPoints.planned.remaining = chartData.storyPoints.planned.remaining - storyPoints;
                        chartData.tasks.planned.remaining = chartData.tasks.planned.remaining - 1;
                        break;

                    case 'UnPlanned':
                        chartData.storyPoints.unPlanned.completed = chartData.storyPoints.unPlanned.completed + storyPoints;
                        chartData.tasks.unPlanned.completed = chartData.tasks.unPlanned.completed + 1;
                        chartData.hours.unPlanned.completed = chartData.hours.unPlanned.completed + completedHours;
                        chartData.storyPoints.unPlanned.remaining = chartData.storyPoints.unPlanned.remaining - storyPoints;
                        chartData.tasks.unPlanned.remaining = chartData.tasks.unPlanned.remaining - 1;
                        break;

                    case 'Previous Sprint':
                        chartData.storyPoints.previousSprint.completed = chartData.storyPoints.previousSprint.completed + storyPoints;
                        chartData.tasks.previousSprint.completed = chartData.tasks.previousSprint.completed + 1;
                        chartData.hours.previousSprint.completed = chartData.hours.previousSprint.completed + completedHours;
                        chartData.storyPoints.previousSprint.remaining = chartData.storyPoints.previousSprint.remaining - storyPoints;
                        chartData.tasks.previousSprint.remaining = chartData.tasks.previousSprint.remaining - 1;
                        break;

                    default:
                        break;
                }
                sprintInstance.set('chartData', chartData);
                sprintInstance.save()
                break;

            default:
                break;
        }

        result.set('taskUpdatedTime', taskUpdatedTime);
        return result;
    }

    async scrumboardListChange(cardId, oldListId, newListId) {
        let task = new this.parseService.instance.Object('Tasks');
        task.id = cardId;
        await this.removeTaskRelation(task, oldListId);
        await this.addTaskRelation(task, newListId)
    }

    addTaskRelation(task, listId) {
        var queryRel = new this.parseService.instance.Query('ProjectBoardLists');
        queryRel.equalTo('objectId', listId);
        queryRel.first().then(function (boardList) {
            var relation = boardList.relation('Tasks');
            relation.add(task);
            boardList.save().then((result) => {
            }, function (error) {
            });
            return boardList;
        });
    }

    removeTaskRelation(task, listId) {
        var queryRel = new this.parseService.instance.Query('ProjectBoardLists');
        queryRel.equalTo('objectId', listId);
        queryRel.first().then(function (boardList) {
            var relation = boardList.relation('Tasks');
            relation.remove(task);
            boardList.save().then((result) => {
            }, function (error) {
            });
            return boardList;
        });
    }

    /**
     * Create new board
     *
     * @param board
     * @returns {Promise<any>}
     */
    createNewBoard(board): Promise<any> {
        return new Promise((resolve, reject) => {

            let scrumboardClass = this.parseService.instance.Object.extend('Scrumboard');
            var scrumboardDetails = new scrumboardClass();
            scrumboardDetails.set('name', board.name);
            scrumboardDetails.set('uri', board.uri);
            scrumboardDetails.set('settings', board.settings);
            scrumboardDetails.save().then(
                res => {
                    board.id = res.id;
                    resolve(board);
                    this.toastr.success('Board created successfully');
                },
                err => {
                    reject;
                }
            );

        });
    }

    async getLabels(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            let queryInstance = this.parseService.instance.Object.extend('DataSettings');
            let query = new this.parseService.instance.Query(queryInstance);
            await query.find().then(results => {
                resolve(results);
            });
        });
    }

    async getProjectMembers(projectId): Promise<any> {
        return new Promise(async (resolve, reject) => {
            let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
            let query = new this.parseService.instance.Query(queryInstance);
            query.include('user');
            query.include('user.profile');
            query.equalTo('status', 'Assigned');
            query.equalTo('project', {
                __type: 'Pointer',
                className: 'Project',
                objectId: projectId
            });
            query.limit(500000);
            query.find().then(results => {
                resolve(results);
            });
        });
    }

}

@Injectable()
export class BoardResolve implements Resolve<any>
{
    /**
     * Constructor
     *
     * @param {ScrumboardService} _scrumboardService
     */
    constructor(
        private _scrumboardService: ScrumboardService
    ) {
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @returns {Promise<any>}
     */
    resolve(route: ActivatedRouteSnapshot): Promise<any> {
        return this._scrumboardService.getBoard(route.paramMap.get('boardId'));
    }
}